import React from "react";
import "../../styles/SplashScreen.css";

const SplashScreen = ({ loadingMessage = "Loading...", hasError = false, onRefresh }) => {
  return (
    <div className="splash-container">
      <div className="splash-content">
        {/* Penguin logo in center of spinner */}
        <div className="spinner-wrapper">
          {!hasError && <div className="spinner-ring"></div>}
          <img
            src="/images/penguin-alone.png"
            alt="Pricing Penguin Logo"
            className="penguin-logo"
            width="120"
            height="120"
          />
        </div>

        {/* Loading message or error */}
        <div className="loading-message">
          {hasError ? (
            <>
              <p className="error-text">Oops! Something went wrong</p>
              <button
                className="refresh-button"
                onClick={onRefresh || (() => window.location.reload())}
              >
                Refresh Page
              </button>
            </>
          ) : (
            <p>{loadingMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
